import angular from 'angular';
class MediaStreamTrackHelper {
    constructor() { }
    //public
    getVideoSize(mediaStreamTrack) {
        return {
            height: this.getSetting(mediaStreamTrack, 'height'),
            width: this.getSetting(mediaStreamTrack, 'width'),
        };
    }
    getDeviceId(mediaStreamTrack) {
        return this.getSetting(mediaStreamTrack, 'deviceId');
    }
    getFacingMode(mediaStreamTrack) {
        return this.getSetting(mediaStreamTrack, 'facingMode');
    }
    // private
    getSetting(mediaStreamTrack, settingName) {
        if (!mediaStreamTrack)
            return undefined;
        if (mediaStreamTrack.getSettings) {
            return mediaStreamTrack.getSettings()[settingName];
        }
        else if (mediaStreamTrack.getConstraints) {
            const facingModeConstrainDOMString = mediaStreamTrack.getConstraints()[settingName];
            return this.getConstrainDOMString(facingModeConstrainDOMString);
        }
        else {
            return undefined;
        }
    }
    getConstrainDOMString(constrainDOMString) {
        switch (true) {
            case Array.isArray(constrainDOMString): {
                return constrainDOMString[0];
            }
            case this.isPrimitive(constrainDOMString): {
                return constrainDOMString;
            }
            case typeof constrainDOMString === 'object' &&
                constrainDOMString !== null:
                {
                    return this.isPrimitive(constrainDOMString.exact)
                        ? constrainDOMString.exact
                        : constrainDOMString.exact[0];
                }
            default: {
                return undefined;
            }
        }
    }
    isPrimitive(value) {
        const type = typeof value;
        return ['number', 'string', 'boolean'].includes(type);
    }
}
export { MediaStreamTrackHelper };
export default angular
    .module('doxy.providers.video.common.services.mediaStreamTrackHelper', [])
    .service('mediaStreamTrackHelper', MediaStreamTrackHelper).name;
